import int01 from "./Introduccion/Intro-01.mp3";
import int02 from "./Introduccion/Intro-02.mp3";
import int03 from "./Introduccion/Intro-03.mp3";
import int04 from "./Introduccion/Intro-04.mp3";
import int05 from "./Introduccion/Intro-05.mp3";

import sub1_act1_a01 from "./Subtema_1/T4-Sub 1- Act 1-A01.mp3";
import sub1_act1_a02 from "./Subtema_1/T4-Sub 1- Act 1-A02.mp3";
import sub1_act1_a03 from "./Subtema_1/T4-Sub 1- Act 1-A03.mp3";
import sub1_act2_a01 from "./Subtema_1/T4-Sub 1- Act 2-A01.mp3";
import sub1_act2_a02 from "./Subtema_1/T4-Sub 1- Act 2-A02.mp3";
import sub1_act2_a03 from "./Subtema_1/T4-Sub 1- Act 2-A03.mp3";
import sub1_act2_a04 from "./Subtema_1/T4-Sub 1- Act 2-A04.mp3";
import sub1_act2_a05 from "./Subtema_1/T4-Sub 1- Act 2-A05.mp3";

import sub2_act1_a01 from "./Subtema_2/T4-Sub 2- Act 1-A01.mp3";
import sub2_act2_a01 from "./Subtema_2/T4-Sub 2- Act 2-A01.mp3";
import sub2_act2_a02 from "./Subtema_2/T4-Sub 2- Act 2-A02.mp3";

import sub3_act1_a01 from "./Subtema_3/T4-Sub 3- Act 1-A01.mp3";
import sub3_act1_a02 from "./Subtema_3/T4-Sub 3- Act 1-A02.mp3";
import sub3_act1_a03 from "./Subtema_3/T4-Sub 3- Act 1-A03.mp3";
import sub3_act2_a01 from "./Subtema_3/T4-Sub 3- Act 2-A01.mp3";
import sub3_act2_a02 from "./Subtema_3/T4-Sub 3- Act 2-A02.mp3";
import sub3_act2_a03 from "./Subtema_3/T4-Sub 3- Act 2-A03.mp3";
import sub3_act2_a04 from "./Subtema_3/T4-Sub 3- Act 2-A04.mp3";

import sub4_act1_a01 from "./Subtema_4/Actividad-1/T4-Sub 4- Act 1-A01.mp3";
import sub4_act1_a02 from "./Subtema_4/Actividad-1/T4-Sub 4- Act 1-A02.mp3";
import sub4_act1_a03 from "./Subtema_4/Actividad-1/T4-Sub 4- Act 1-A03.mp3";
import sub4_act2_a01 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-A01.mp3";
import sub4_act2_a02 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-N02.mp3";
import sub4_act2_a03 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-A03.mp3";
import sub4_act2_a04 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-N04.mp3";
import sub4_act2_a05 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-Y05.mp3";
import sub4_act2_a06 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-N06.mp3";
import sub4_act2_a07 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-N07.mp3";
import sub4_act2_a08 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-Y08.mp3";
import sub4_act2_a09 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-A09.mp3";
import sub4_act2_a10 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-N10.mp3";
import sub4_act2_a11 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-N11.mp3";
import sub4_act2_a12 from "./Subtema_4/Actividad-2/T4-Sub 4- Act 2-Y12.mp3";
import sub4_act3_a01 from "./Subtema_4/Actividad-3/T4-Sub 4- Act 3-A01.mp3";
import sub4_act3_a02 from "./Subtema_4/Actividad-3/T4-Sub 4- Act 2-A02.mp3";
import sub4_act3_a03 from "./Subtema_4/Actividad-3/T4-Sub 4- Act 3-N03.mp3";
import sub4_act3_a04 from "./Subtema_4/Actividad-3/T4-Sub 4- Act 3-A04.mp3";
import sub4_act3_a05 from "./Subtema_4/Actividad-3/T4-Sub 4- Act 3-A05.mp3";
import sub4_act3_a06 from "./Subtema_4/Actividad-3/T4-Sub 4- Act 3-N06.mp3";
import sub4_act3_a07 from "./Subtema_4/Actividad-3/T4-Sub 4- Act 3-Y07.mp3";
import sub4_act3_a08 from "./Subtema_4/Actividad-3/T4-Sub 4- Act 3-A08.mp3";
import sub4_act4_a01 from "./Subtema_4/Actividad-4/T4-Sub 4- Act 4-A01.mp3";
import sub4_act4_a02 from "./Subtema_4/Actividad-4/T4-Sub 4- Act 4-N02.mp3";
import sub4_act4_a03 from "./Subtema_4/Actividad-4/T4-Sub 4- Act 4-AM03.mp3";
import sub4_act4_a04 from "./Subtema_4/Actividad-4/T4-Sub 4- Act 4-N04.mp3";
import sub4_act4_a05 from "./Subtema_4/Actividad-4/T4-Sub 4- Act 4-N05.mp3";
import sub4_act4_a06 from "./Subtema_4/Actividad-4/T4-Sub 4- Act 4-N06.mp3";
import sub4_act4_a07 from "./Subtema_4/Actividad-4/T4-Sub 4- Act 4-AM07.mp3";
import sub4_act4_a08 from "./Subtema_4/Actividad-4/T4-Sub 4- Act 4-N08.mp3";
import sub4_act5_a01 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-A01.mp3";
import sub4_act5_a02 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-N02.mp3";
import sub4_act5_a03 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-AM03.mp3";
import sub4_act5_a04 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-N04.mp3";
import sub4_act5_a05 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-A05.mp3";
import sub4_act5_a06 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-A06.mp3";
import sub4_act5_a07 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-N07.mp3";
import sub4_act5_a08 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-AM08.mp3";
import sub4_act5_a09 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-N09.mp3";
import sub4_act5_a10 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-AM10.mp3";
import sub4_act5_a11 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-A11.mp3";
import sub4_act5_a12 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-A12.mp3";
import sub4_act5_a13 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-N13.mp3";
import sub4_act5_a14 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-AM14.mp3";
import sub4_act5_a15 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-N15.mp3";
import sub4_act5_a16 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-N16.mp3";
import sub4_act5_a17 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-AM17.mp3";
import sub4_act5_a18 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-N18.mp3";
import sub4_act5_a19 from "./Subtema_4/Actividad-5/T4-Sub 4- Act 5-A19.mp3";

import sub5_act1_a01 from "./Subtema_5/Actividad-1/T4-Sub 5- Act 1-A01.mp3";
import sub5_act1_a02 from "./Subtema_5/Actividad-1/T4-Sub 5- Act 1-N02.mp3";
import sub5_act1_a03 from "./Subtema_5/Actividad-1/T4-Sub 5- Act 1-Y03.mp3";
import sub5_act1_a04 from "./Subtema_5/Actividad-1/T4-Sub 5- Act 1-A04.mp3";
import sub5_act2_a01 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-A01.mp3";
import sub5_act2_a02 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-N02.mp3";
import sub5_act2_a03 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-Y03.mp3";
import sub5_act2_a04 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-N04.mp3";
import sub5_act2_a05 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-N05.mp3";
import sub5_act2_a06 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-Y06.mp3";
import sub5_act2_a07 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-N07.mp3";
import sub5_act2_a08 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-Y08.mp3";
import sub5_act2_a09 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-N09.mp3";
import sub5_act2_a10 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-A10.mp3";
import sub5_act2_a11 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-A11.mp3";
import sub5_act2_a12 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-N12.mp3";
import sub5_act2_a13 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-Y13.mp3";
import sub5_act2_a14 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-N14.mp3";
import sub5_act2_a15 from "./Subtema_5/Actividad-2/T4-Sub 5- Act 2-A15.mp3";

import sub6_act1_a01 from "./Subtema_6/T4-Sub 6- Act 1-A01.mp3";
import sub6_act1_a02 from "./Subtema_6/T4-Sub 6- Act 1-A02.mp3";
import sub6_act1_a03 from "./Subtema_6/T4-Sub 6- Act 1-A03.mp3";
import sub6_act1_a04 from "./Subtema_6/T4-Sub 6- Act 1-A04.mp3";
import sub6_act2_a01 from "./Subtema_6/T4-Sub 6- Act 2-A01.mp3";

// ... (las importaciones anteriores)

export const T4_voices = {
	introduccion: {
		int01,
		int02,
		int03,
		int04,
		int05,
	},
	sub01: {
		sub1_act1_a01,
		sub1_act1_a02,
		sub1_act1_a03,
		sub1_act2_a01,
		sub1_act2_a02,
		sub1_act2_a03,
		sub1_act2_a04,
		sub1_act2_a05,
	},
	sub02: {
		sub2_act1_a01,
		sub2_act2_a01,
		sub2_act2_a02,
	},
	sub03: {
		sub3_act1_a01,
		sub3_act1_a02,
		sub3_act1_a03,
		sub3_act2_a01,
		sub3_act2_a02,
		sub3_act2_a03,
		sub3_act2_a04,
	},
	sub04: {
		sub4_act1_a01,
		sub4_act1_a02,
		sub4_act1_a03,
		sub4_act2_a01,
		sub4_act2_a02,
		sub4_act2_a03,
		sub4_act2_a04,
		sub4_act2_a05,
		sub4_act2_a06,
		sub4_act2_a07,
		sub4_act2_a08,
		sub4_act2_a09,
		sub4_act2_a10,
		sub4_act2_a11,
		sub4_act2_a12,
		sub4_act3_a01,
		sub4_act3_a02,
		sub4_act3_a03,
		sub4_act3_a04,
		sub4_act3_a05,
		sub4_act3_a06,
		sub4_act3_a07,
		sub4_act3_a08,
		sub4_act4_a01,
		sub4_act4_a02,
		sub4_act4_a03,
		sub4_act4_a04,
		sub4_act4_a05,
		sub4_act4_a06,
		sub4_act4_a07,
		sub4_act4_a08,
		sub4_act5_a01,
		sub4_act5_a02,
		sub4_act5_a03,
		sub4_act5_a04,
		sub4_act5_a05,
		sub4_act5_a06,
		sub4_act5_a07,
		sub4_act5_a08,
		sub4_act5_a09,
		sub4_act5_a10,
		sub4_act5_a11,
		sub4_act5_a12,
		sub4_act5_a13,
		sub4_act5_a14,
		sub4_act5_a15,
		sub4_act5_a16,
		sub4_act5_a17,
		sub4_act5_a18,
		sub4_act5_a19,
	},
	sub05: {
		sub5_act1_a01,
		sub5_act1_a02,
		sub5_act1_a03,
		sub5_act1_a04,
		sub5_act2_a01,
		sub5_act2_a02,
		sub5_act2_a03,
		sub5_act2_a04,
		sub5_act2_a05,
		sub5_act2_a06,
		sub5_act2_a07,
		sub5_act2_a08,
		sub5_act2_a09,
		sub5_act2_a10,
		sub5_act2_a11,
		sub5_act2_a12,
		sub5_act2_a13,
		sub5_act2_a14,
		sub5_act2_a15,
	},
	sub06: {
		sub6_act1_a01,
		sub6_act1_a02,
		sub6_act1_a03,
		sub6_act1_a04,
		sub6_act2_a01,
	},
};
